import {ApplicationRef, enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from '@app/app.module';
import {environment} from './environments/environment';
import * as Sentry from '@sentry/angular';
import {enableDebugTools} from "@angular/platform-browser";

if (environment.production) {
  Sentry.init({
    environment: environment.name,
    release: environment.version,
    // Ignore HttpErrorResponse errors
    ignoreErrors: ['Non-Error exception captured'],
    dsn: 'https://d14d5d144a0f548016af646e1ea37ab1@o4509677889847296.ingest.de.sentry.io/4509677899284560',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration()
    ],
    tracesSampleRate: 0.5,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,
  });

  if (!localStorage.getItem('debug')) {
    enableProdMode();
  }
}

function main() {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .then(module => enableDebugTools(module.injector.get(ApplicationRef).components[0]))
    .catch(err => console.error(err));
}

if (document.readyState === 'complete') {
  main()
} else {
  document.addEventListener('DOMContentLoaded', main);
}
